import { render, staticRenderFns } from "./HouseholdDivisionCard.vue?vue&type=template&id=4d950a36&scoped=true&"
import script from "./HouseholdDivisionCard.vue?vue&type=script&lang=js&"
export * from "./HouseholdDivisionCard.vue?vue&type=script&lang=js&"
import style0 from "./HouseholdDivisionCard.vue?vue&type=style&index=0&id=4d950a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d950a36",
  null
  
)

export default component.exports